import styled, { css } from 'styled-components/macro';
import { Link } from 'react-router-dom';
import * as colors from '../common/colorConstants';
import * as breakpoints from '../common/mediaQueries';

export const Container = styled.div`
  background-color: ${colors.white};
  position: absolute;
  bottom: 0px;
  top: 0px;
  left: 0px;
  right: 0px;
  z-index: 0;
  display: flex;

  @media screen and (max-width: ${breakpoints.minTablet}) {
    background-color: ${colors.activeInputGray};
  }
`;

export const LoginBox = styled.div`
  background-color: ${colors.baseBackground};
  width: 100%;
  margin: 223px auto auto;
  @media screen and (max-width: ${breakpoints.minLaptop}) {
    margin: 180px auto auto;
  }
  @media screen and (max-width: ${breakpoints.minTablet}) {
    background-color: ${colors.activeInputGray};
    margin: 52px auto auto;
  }
  @media screen and (max-width: ${breakpoints.maxMobile}) {
    margin: 52px 0px 0px 0px;
  }
`;

export const Title = styled.div`
  margin: 0 0 11px;
  padding: 0;
  color: ${colors.gulfBlue};
  font-family: 'Roboto', sans-serif;
  font-size: 20px;
  font-weight: 500;
  line-height: 23px;
  text-align: left;
`;

export const Error = styled.div`
  text-align: left;
  color: red;
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 12px;
  margin: 4px 0 0 0;
  background-image: url('/images/error-esclamation.svg');
  background-repeat: no-repeat;
  background-position: center left;
  padding-left: 14px;
  background-size: 10px;
`;

export const Form = styled.form`
  text-align: center;
`;

export const ResetLink = styled(Link)`
  font-size: 11px;
  color: ${colors.electricBlue};
  text-decoration: none;
`;

export const ResetLinkContainer = styled.div`
  margin-top: 12px;

  @media screen and (max-width: ${breakpoints.minLaptop}) {
    margin-top: 16px;
  }

  @media screen and (max-width: ${breakpoints.minTablet}) {
    margin-top: 20px;
  }
`;

export const ReCAPTCHAWrapper = styled.div`
  justify-content: center;
  padding-top: 16px;
  transform: scale(0.9869);

  @media screen and (max-width: ${breakpoints.minLaptop}) {
    transform: scale(0.8454);
  }

  @media screen and (max-width: ${breakpoints.minTablet}) {
    transform: scale(1.0559);
    padding-top: 16px;
  }
`;

export const SubmitWrapper = styled.div`
  padding-top: 19px;
  display: flex;
  width: 100%;
  max-width: 400px;
  gap: 8px;

  @media screen and (max-width: ${breakpoints.maxTablet}) {
    flex-direction: column;
    gap: 12px;
  }

  @media screen and (min-width: ${breakpoints.maxTablet}) {
    flex-direction: row;
  }

  @media screen and (max-width: ${breakpoints.minTablet}) {
    padding-top: 20px;
  }

  @media screen and (max-width: ${breakpoints.minLaptop}) {
    padding-top: 27px;
  }
`;

export const Submit = styled.button`
  flex-grow: 3;
  border: none;
  border-radius: 3px;
  height: 30px;
  background: ${colors.blue2};
  color: ${colors.white};
  font-family: Roboto, sans-serif;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  line-height: 16px;

  @media screen and (max-width: ${breakpoints.maxTablet}) {
    height: 40px;
  }

  &:disabled {
    background: ${colors.disabledBlue};
    cursor: default;
  }
`;

export const PrivacyAndTermsWrapper = styled.div`
  margin-top: 6px;
`;

export const smallTextStyles = css`
  color: ${colors.lightGray20};
  font-family: Roboto, sans-serif;
  font-size: 10px;
  line-height: 16px;
`;

export const SmallLinkExternal = styled.a`
  ${smallTextStyles};
  color: ${colors.purple1};
  text-decoration: none;
`;

export const SmallText = styled.p`
  margin: 0;
  padding: 0;
  ${smallTextStyles};
`;

export const ContentWrapper = styled.div`
  position: relative;
  padding: 0 56px;
  text-align: left;
  max-width: 412px;
  margin: 0 auto;

  @media screen and (max-width: ${breakpoints.minLaptop}) {
    max-width: 369px;
  }

  @media screen and (max-width: ${breakpoints.minTablet}) {
    padding: 0 24px;
  }
`;

export const textStyles = css`
  color: ${colors.darkGray14};
  font-family: Roboto, sans-serif;
  font-size: 11px;
  line-height: 16px;
  margin-top: 16px;

  @media screen and (max-width: ${breakpoints.minLaptop}) {
    margin-top: 18px;
  }

  @media screen and (max-width: ${breakpoints.minTablet}) {
    margin-top: 24px;
  }

  @media screen and (max-width: ${breakpoints.maxTablet}) {
    font-size: 14px;
    line-height: 18px;
  }
`;

export const Input = css`
  padding: 11px 16px;
  border: 1px solid ${colors.lightGray21};
  border-radius: 3px;
  width: 100%;
  ${textStyles};
  color: ${colors.lightBlack};
  background-color: ${colors.white};
  outline: none;

  &.error {
    border: 1px solid ${colors.red3};
  }

  &.error {
    background-color: ${colors.intentValidation.red2};
  }

  &::placeholder {
    ${textStyles};
  }

  &:focus {
    border: 1px solid ${colors.blue1};
    background-color: ${colors.activeInputGray};
  }

  &:disabled {
    color: ${colors.lightGray5};
    background-color: ${colors.lightGray14};
    font-weight: bold;
  }
`;

export const TextInput = styled.input`
  ${Input};
`;

export const PasswordInput = styled.input`
  ${Input};
  padding-right: 25px;
`;

export const PasswordWrapper = styled.div`
  position: relative;
`;

export const PasswordIcon = styled.div`
  position: absolute;
  right: 12px;
  bottom: 12px;
  cursor: pointer;
  width: 16px;
  height: 16px;
`;

export const BackLinkWrapper = styled.div`
  flex-grow: 1;

  @media screen and (max-width: ${breakpoints.maxTablet}) {
    order: 2;
  }
`;
